module.exports = __webpack_public_path__ + "static/media/fb.d9b0eab1.svg";